import { FC } from "react";
import { Progress } from "../../../../redux/types";
import { Stepper, Step, StepLabel } from "@mui/material";
import { AppCSS } from "../../../../components";

interface ProgresProps {
  progress?: Progress[];
}

//const useStyles = makeStyles(() => ({
//  root: {
//    "& .MuiStepIcon-active": { color: AppCSS.GLAS_BLUE },
//    "& .MuiStepIcon-completed": { color: AppCSS.GLAS_GREEN },
//    "& .Mui-disabled .MuiStepIcon-root": { color: AppCSS.GRAY_LIGHT },
//  },
//}));

export const ProgressSlider: FC<ProgresProps> = ({ progress }) => {
  if (!Array.isArray(progress)) {
    return <></>;
  }

  let activeStep = 0;
  progress.forEach((item, index) => {
    if (item.completed === true) {
      activeStep = index + 1;
    }
    return;
  });

  return (
    <div
      style={{
        margin: 10,
        width: "100%",
        height: "42px",
      }}
    >
      <Stepper activeStep={activeStep}>
        {progress.map((items, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};

          return (
            <Step key={index} {...stepProps}>
              <StepLabel {...labelProps}>
                <p
                  style={{
                    fontSize: "0.5rem",
                  }}
                >
                  {items.goal.replaceAll("_", " ").toUpperCase()}
                </p>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};
